import { Component, OnInit, Input, Inject } from '@angular/core';
import { BusinessInfo } from 'src/app/Models/BusinessInfoResponse';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppComponent } from 'src/app/app.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.component.html',
  styleUrls: ['./business-info.component.css']
})
export class BusinessInfoComponent implements OnInit {

  constructor(public service: SharkifyAiSerivceService, public router: Router, public dialog: MatDialog, public app: AppComponent, public route: ActivatedRoute) { }
  UserId: string = "";
  noData: boolean = true;
  // BusinessInfo_BusinessName: string = "";
  Content_Requirements_Sample_Images: string[] = [];
  Business_Specific_Uploads_Images: string[] = [];
  ContentRequirements_SampleImages: string[] = [];
  BusinessSpecificUploads_Images: string[] = [];
  BusinessInfos: BusinessInfo[] = [];
  EditBusinessInfos: any;
  InfoId: number = -1;
  UserName: string = "";
  gotlength: boolean = false;
  ngOnInit(): void {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.UserName = this.getSafeValue(localStorage.getItem("UserName"));
    this.InfoId = this.service.getBusinessInfo();
    this.InfoId = Number(this.getSafeValue(localStorage.getItem("InfoId")));

    if (this.InfoId != -1) {
      this.gotlength = true;
    }
    else {
      console.error("Error passing data");
    }

    this.GetData();
  }

  GetData() {

    this.service.GetBusinessInfoDetails(this.UserId).subscribe(data => {
      this.app.displayLoader(true);
      this.BusinessInfos = data;
        if (!Array.isArray(this.BusinessInfos)) {
          this.BusinessInfos = [this.BusinessInfos];
          this.setimages();
          this.app.displayLoader(false);
        }
        if (this.InfoId && this.gotlength) {
          let k: number = -1;
          let length = this.BusinessInfos.length;
          for (let i = 0; i < length; i++) {
            if (this.BusinessInfos[i].BusinessInfoId === this.InfoId) {
              k = i;
              break;
            }
          }
          if (k !== -1) {
            const selectedBusinessInfo = this.BusinessInfos[k];
            this.BusinessInfos = [selectedBusinessInfo];
            this.app.displayLoader(false);
          }
          this.setimages();
          this.app.displayLoader(false);
        }
        this.app.displayLoader(false);

      this.app.displayLoader(false);
    });
  }
  setimages() {
    this.ContentRequirements_SampleImages = this.BusinessInfos[0].ContentRequirements_SampleImages.split(', ');
    this.Content_Requirements_Sample_Images = [];
    if (this.ContentRequirements_SampleImages.length > 0) {
      for (let i = 0; i < this.ContentRequirements_SampleImages.length; i++) {
        this.Content_Requirements_Sample_Images.push(this.ContentRequirements_SampleImages[i]);
      }
    } else {
      this.Content_Requirements_Sample_Images[0] = '';
    }
    this.BusinessSpecificUploads_Images = this.BusinessInfos[0].BusinessSpecificUploads_Images.split(', ');
    this.Business_Specific_Uploads_Images = [];
    if (this.BusinessSpecificUploads_Images.length > 0) {
      for (let i = 0; i < this.BusinessSpecificUploads_Images.length; i++) {
        this.Business_Specific_Uploads_Images.push(this.BusinessSpecificUploads_Images[i]);
      }
    } else {
      this.Business_Specific_Uploads_Images[0] = '';

    }
  }
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }

  onEdit(i: number) {
    this.service.setBusinessInfo(this.BusinessInfos[i]);
    this.EditBusinessInfos = this.BusinessInfos[i];
    // localStorage.setItem("BusinessInfos",""+ this.BusinessInfos);
    localStorage.setItem("EditBusinessInfos", JSON.stringify(this.EditBusinessInfos));
    this.router.navigate(['/Dashboard/EditBusinessInfo']);
  }

  deletedata(name: string, Id: string) {
    const dialogData = {
      UserId: this.UserId,
      BusinessName: name,
      BusinessInfoId: Id,
      UserName: this.UserName,

    };
    const dialogRef = this.dialog.open(DeleteBusinessInfoDailog, {
      height: 'auto',
      width: '500px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(result => {
      var SelectedStaus = result.SelectionType
      if (SelectedStaus == "Success") {
        this.GetData();
      }
    });
  }

}
export interface DeleteBusinessInfoData {
  BusinessName: string;
  UserId: string;
  BusinessInfoId: string;
  UserName: string;
}
@Component({
  selector: 'app-deletebusinessinfodailog',
  templateUrl: './deletebusinessinfodailog.component.html'
})
export class DeleteBusinessInfoDailog {
  constructor(public service: SharkifyAiSerivceService,
    public dialogRef: MatDialogRef<DeleteBusinessInfoDailog>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteBusinessInfoData) {
    this.BusinessName = data.BusinessName;
    this.UserName = data.UserName;
  }
  BusinessName;
  UserName;
  ngOnInit() {

  }
  onYesClick() {
    this.service.DeleteBusinessInfo("1", "1").subscribe(data => {
      if (data.Code == 200) {
        this.dialogRef.close({ SelectionType: 'Success' });
      } else {
      }
    });
  }
  onNoClick() {
    this.dialogRef.close({ SelectionType: 'Cancel' });
  }
}